export default "__VITE_ASSET__DeBdx7ab__"